
import React, { useState } from "react";
import "./PremiumButton.css";

const PremiumButton = ({
  children,
  onClick,
  disabled = false,
  fullWidth = false,
  fontSize = "15px",
  type = "button",
  ...rest
}) => {
  const [isPressed, setIsPressed] = useState(false);

  return (
    <div className={`casino-btn-wrap ${fullWidth ? "casino-btn-wrap--full" : ""}`}>
      {/* Top center golden glow on border */}
      <div className="casino-btn-glow" aria-hidden="true" />

      <button
        type={type}
        className={`casino-btn ${isPressed ? "casino-btn--pressed" : ""} ${fullWidth ? "casino-btn--full" : ""}`}
        onClick={onClick}

        style={{ fontSize: fontSize }}
        disabled={disabled}
        onMouseDown={() => !disabled && setIsPressed(true)}
        onMouseUp={() => setIsPressed(false)}
        onMouseLeave={() => setIsPressed(false)}
        {...rest}
      >
        {/* Top inner warm glow - faint golden light at the top inside */}
        <span className="casino-btn-inner-glow" aria-hidden="true" />
        {/* Very subtle noise/texture overlay for matte feel */}
        <span className="casino-btn-texture" aria-hidden="true" />
        {children}
      </button>
    </div>
  );
};

export default PremiumButton;
